import FreeMailOfferCard from './FreeMailOfferCard'

export default FreeMailOfferCard
